import React from 'react';
import { motion } from 'framer-motion';
import { pageWrapperStyle } from '../../styles/pageStyles.js';
import './PolicyPage.css';

const DataProcessingAgreement = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ ...pageWrapperStyle, backgroundColor: 'var(--alt-background)' }}
    >
      <section className="policy-page section">
        <div className="container">
          <div className="policy-content">
            <h1>Data Processing Agreement (DPA)</h1>
            <p className="last-updated">Last updated: June 11, 2025</p>

            <p>This Data Processing Agreement applies to any processing of personal data undertaken by Digital Fig Ltd on behalf of clients in accordance with the UK GDPR and applicable data protection laws.</p>

            <h2>1. Scope</h2>
            <p>This DPA outlines how we process, protect, and manage personal data received from our clients ("Controllers").</p>

            <h2>2. Data Processing Terms</h2>
            <p>We:</p>
            <ul>
              <li>Act solely under your documented instructions</li>
              <li>Do not sell or share personal data with third parties without consent</li>
              <li>Maintain appropriate technical and organisational safeguards</li>
              <li>Ensure data confidentiality, integrity, and availability</li>
            </ul>

            <h2>3. Sub-processors</h2>
            <p>We may use trusted third-party tools (e.g., hosting providers, analytics services) and ensure they meet equivalent data protection standards. A list of sub-processors is available upon request.</p>

            <h2>4. Data subject rights</h2>
            <p>We will assist you in fulfilling data subject rights requests, such as access, rectification, erasure, or data portability, within a reasonable timeframe.</p>

            <h2>5. Breach notification</h2>
            <p>In the unlikely event of a personal data breach, we will notify you without undue delay and provide details of the incident and steps taken to mitigate it.</p>

            <h2>6. Deletion or return of data</h2>
            <p>Upon termination of the relationship, we will delete or return all personal data as instructed, unless retention is required by law.</p>

            <h2>7. Governing law</h2>
            <p>This DPA is governed by the laws of England and Wales.</p>

            <p>For enquiries or to request a signed copy, please contact us at <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a>.</p>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default DataProcessingAgreement;